// @flow

export default {
  CART_KEY: 'op_cart_key',
  CART_EXPIRED_AT: 'op_cart_expired_at',
  PREFERRED_SHIPPING_COUNTRY: 'op_preferred_shipping_country',
  TRACKING: 'op_tracking_v2',
  XSRF_TOKEN: 'XSRF-TOKEN',
  DOMAIN_REDIRECT_ALERT: 'op_domain_redirect_alert'
};
